<template>
    <div class="watcher">
        <span class="watcher__follow" @click.prevent="changeFollowStatus">
            <span :class="{ 'no-follow': !isFollowing }" class="watcher__svgFollow">
                <img
                    v-if="isFollowing"
                    v-lazy-load
                    width="15"
                    height="20"
                    src="/nuxt-assets/images/lazy-load-error.svg"
                    data-src="/nuxt-assets/images/icons/checkbox-checked.svg"
                />
            </span>
            {{ isFollowing ? $t('discussions.unWatching') : $t('discussions.watchingDiscussions') }}
        </span>
    </div>
</template>

<script lang="ts">
import DiscussionGetUser from '~/models/Api/DiscussionGetUser'
import { useAuthStore } from '~/stores/auth'
import { useBasketStore } from '~/stores/basket'

export default {
    components: {},

    props: {
        productId: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            isFollowing: false as Boolean,
            watchDog: {} as DiscussionGetUser,
        }
    },
    async fetch(): Promise<void> {
        if (this.isUserAuthenticated) {
            const authStore = useAuthStore()
            const accessToken: string | null = authStore.accessToken
            const watchDog = await this.$repository.discussionGetWatchdog(this.productId, { accessToken })

            if (watchDog) {
                this.watchdogId = watchDog.id || 0
                this.isFollowing = this.watchdogId > 0
            }
        }
    },
    computed: {
        authUser(): object | null {
            const basketStore = useBasketStore()
            return basketStore.authUser
        },
        isUserAuthenticated(): boolean {
            return this.authUser !== null
        },
    },
    methods: {
        changeFollowStatus() {
            if (this.isUserAuthenticated) {
                const authStore = useAuthStore()
                const accessToken: string | null = authStore.accessToken
                this.isFollowing = !this.isFollowing
                this.$repository.discussionUpsertWatchdog(this.productId, 'once_a_day', { accessToken })
            } else {
                useNuxtApp().$bus.$emit('openModalForLogin')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.watcher {
    display: flex;
    align-items: center;

    &__follow {
        color: $color-green-dark;
        cursor: pointer;
        font-weight: 500;
        display: flex;
        white-space: nowrap;
        line-height: 25px;
    }

    &__svgFollow {
        background: $color-green-dark;
        padding: 0 0.25rem;
        border-radius: 5px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        border: 2px solid $color-green-dark;

        img {
            height: 11px;
        }

        &.no-follow {
            background: transparent;
            border: 2px solid $color-green-dark;
            width: 27px;
        }
    }
}
</style>
